/* HejBuddy tuotegalleria.
   Natiivi scroll-snap hoitaa vetämisen. Tämä hoitaa vain aktiivisen
   indeksin, peukaloradan keskityksen ja varianttisynkan. */

class HbGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hb-track]');
    this.rail = this.querySelector('[data-hb-rail]');
    this.counter = this.querySelector('[data-hb-counter]');
    this.thumbs = Array.from(this.querySelectorAll('[data-hb-thumb]'));
    this.slides = Array.from(this.querySelectorAll('.hb-gal__slide'));
    this.count = this.slides.length;
    this.index = 0;
    this.pending = null;

    if (!this.track || this.count < 2) return;

    this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

    this.thumbs.forEach(b => b.addEventListener('click', () => this.goTo(+b.dataset.index)));

    const prev = this.querySelector('[data-hb-prev]');
    const next = this.querySelector('[data-hb-next]');
    // Indeksi luetaan elävästä scroll-asemasta, ei tallennetusta tilasta:
    // muuten kesken pehmeän siirtymän tullut klikkaus katoaa.
    if (prev) prev.addEventListener('click', () => this.goTo(this.liveIndex() - 1));
    if (next) next.addEventListener('click', () => this.goTo(this.liveIndex() + 1));

    // Variantin vaihto (Dawn-tyyliset teemat)
    document.addEventListener('variant:change', e => {
      const id = e.detail && e.detail.variant && e.detail.variant.featured_media && e.detail.variant.featured_media.id;
      if (id) this.goToMedia(id);
    });

    const startId = this.dataset.startMedia;
    if (startId) {
      const i = this.slides.findIndex(s => s.dataset.mediaId === String(startId));
      if (i > 0) this.jumpTo(i);
    }
    this.sync(this.index);
  }

  step() {
    const first = this.slides[0];
    if (!first) return this.track.clientWidth || 1;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  clamp(i) { return Math.max(0, Math.min(this.count - 1, i)); }

  liveIndex() {
    const now = Math.round(this.track.scrollLeft / this.step());
    return this.pending != null && this.pending !== now ? this.pending : now;
  }

  goTo(i) {
    const target = this.clamp(i);
    this.pending = target;
    this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
    this.sync(target);
  }

  jumpTo(i) {
    const target = this.clamp(i);
    this.track.scrollTo({ left: target * this.step(), behavior: 'auto' });
    this.sync(target);
  }

  goToMedia(mediaId) {
    const i = this.slides.findIndex(s => s.dataset.mediaId === String(mediaId));
    if (i >= 0) this.goTo(i);
  }

  onScroll() {
    const i = this.clamp(Math.round(this.track.scrollLeft / this.step()));
    if (this.pending === i) this.pending = null;
    if (i !== this.index) this.sync(i);
  }

  sync(i) {
    this.index = i;

    if (this.counter) this.counter.innerHTML = (i + 1) + '&nbsp;/&nbsp;' + this.count;

    this.thumbs.forEach((t, n) => {
      const active = n === i;
      t.classList.toggle('is-active', active);
      if (active) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });

    const prev = this.querySelector('[data-hb-prev]');
    const next = this.querySelector('[data-hb-next]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === this.count - 1;

    this.centerRail(i);
  }

  centerRail(i) {
    if (!this.rail) return;
    const first = this.thumbs[0];
    if (!first) return;
    const w = first.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
    const left = Math.max(0, i * (w + gap) - this.rail.clientWidth / 2 + w / 2);
    this.rail.scrollTo({ left, behavior: 'smooth' });
  }
}

if (!customElements.get('hb-gallery')) customElements.define('hb-gallery', HbGallery);
